import { GetAllInvitationsInDto, GetAllInvitationsOutDto } from '../../../types/invitation.dto'

export const GET_ALL_INVITATIONS = 'GET_ALL_INVITATIONS'
export const GET_ALL_INVITATIONS_SUCCESS = 'GET_ALL_INVITATIONS_SUCCESS'
export const GET_ALL_INVITATIONS_ERROR = 'GET_ALL_INVITATIONS_ERROR'
export const RESET_GET_ALL_INVITATIONS = 'RESET_GET_ALL_INVITATIONS'
export const UPDATE_INVITATIONS = 'UPDATE_INVITATIONS'

export interface GetAllInvitations {
  type: typeof GET_ALL_INVITATIONS
  payload: GetAllInvitationsOutDto
}

export interface GetAllInvitationsSuccess {
  type: typeof GET_ALL_INVITATIONS_SUCCESS
  payload: GetAllInvitationsInDto
}

export interface GetAllInvitationsError {
  type: typeof GET_ALL_INVITATIONS_ERROR
  payload: string | boolean
}

export interface ResetGetAllInvitations {
  type: typeof RESET_GET_ALL_INVITATIONS
  payload: null
}

export interface UpdateInvitations {
  type: typeof UPDATE_INVITATIONS
  payload: GetAllInvitationsInDto
}

export interface State {
  data: GetAllInvitationsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllInvitations
  | GetAllInvitationsSuccess
  | GetAllInvitationsError
  | ResetGetAllInvitations
  | UpdateInvitations
